export default "__VITE_ASSET__XHnCKZgn__"